import { render, staticRenderFns } from "./getTrials.vue?vue&type=template&id=01a5cde9&scoped=true"
import script from "./getTrials.vue?vue&type=script&lang=js"
export * from "./getTrials.vue?vue&type=script&lang=js"
import style0 from "./getTrials.vue?vue&type=style&index=0&id=01a5cde9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5cde9",
  null
  
)

export default component.exports